// Shimmering Prism — vertex shader (RawShaderMaterial).
// Byte-identical to the standalone demo (src/newbackground/js/shaders/vertex.js).
// RawShaderMaterial does not auto-inject declarations, so the built-in
// modelViewMatrix / projectionMatrix uniforms and the position attribute are
// declared explicitly here; Three.js still binds their values by name.
export default `
uniform mat4 modelViewMatrix;
uniform mat4 projectionMatrix;

attribute vec3 position;

void main() {

    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

}
`;
